import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Traducciones
const resources = {
    en: {
        translation: {
            "welcome": "WELCOME",
            "meet_the_team": "Meet the Team",
            "ezequiel_title": "Applied Physics Engineer - Technological University of the Mixteca",
            "michelle_title": "Applied Physics Engineer - Technological University of the Mixteca",
            "erick_title": "Mechatronic Engineer - Technological University of the Mixteca",
            "tomas_title": "Mechatronic Engineer - Technological University of the Mixteca",
            "emma_title": "Mechatronic Engineer - Technological University of the Mixteca",
            "alejandro_title": "Mechatronic Engineer - Technological University of the Mixteca",
            "jorge_title": "Master of Science in Applied Computing Technologies - Technological University of the Mixteca",
            "omar_title":"Computer Engineer - Technological University of the Mixteca",
            "engineer": "Eng.",
            "master": "Master.",
            "developer": "Developer",
            "constellation": "Draw your own Constellation!",
            "searchPlanet": "Search for an exoplanet",
            "success": "Success",
            "imageSaved": "Image has been saved to your account!",
            "error": "Error",
            "failedToSaveImage": "Failed to save image.",
            "warning": "Warning",
            "needToBeLoggedIn": "You need to be logged in to save images to your account.",
            "pleaseEnterPlanetName": "Please enter an exoplanet name.",
            "loadingStarMap": "Loading Star Map.",
            "errorFetchingStarMap": "Error fetching the star map.",
            "errorFetchingStarMapRetry": "Error fetching the star map. Please try again.",
            "title_team": "Our team",
            "data_planet": "Data of the exoplanets",
            "planetName": "Exoplanet Name",
            "planetRadius": "Exoplanet Radius [Earth's times]",
            "planetMass": "Exoplanet Mass [Earth's times]",
            "planetEccentricity": "Orbital Eccentricity",
            "planetGaiaMagnitude": "Gaia Magnitude",
            "planetOrbitalPeriod": "Orbital Period [days]",
            "planetDistance": "Distance [parsecs]",
            "planetDiscoveredMethod": "Discovered Method",
            "planetDiscoveredYear": "Discovered Year",
            "planetHostStar": "Star (Hostname)",
            "planetStarsNumber": "Number of Stars",
            "planetPlanets" : "Number of Exoplanets",
            "planetClassification": "Classification of the stars",
            "drawTitle": "Stelar Map",
            "drawButton": "Show 3D Nearby Space",
            "drawP": "Type the name of a exoplanet to see its stelar map",
            "blog": "Blog",
            "blogInput": "Search for a blog",
            "blogRecent": "Recent Posts",
            "blogOlder": "Older Posts",
            "infoMessage": "The page may take a while to load if there has been no recent activity. Please be patient.",
            "titleMail": "Contact Us",
            "mail": "Email:",
            "mailType": "Enter your email",
            "subject": "Subject",
            "subjectType": "Enter the subject",
            "phoneNumber": "Phone Number",
            "phoneType": "Enter your phone number",
            "body": "Message, doubt, question, comment, suggestion, etc.",
            "bodyType": "Type here",
            "sendEmail": "Send",
            "planetDetails": "Exoplanet details:",
            "planetComparison": "Exoplanets Comparison",
            "filterPlanets": "Filter Exoplanets",
            "infoPlanets": "The actual order of the exoplanets is based in Distance from Earth, from the closest to the farthest, or you can filter by exoplanet name, year of discovery, discovery method or planet radius.",
            "description_team": "We are a multidisciplinary team composed of professionals from different areas. Our goal is to develop novel ideas that not only address current problems, but also bring knowledge and technology closer to more people, regardless of their background or educational level. We believe that information should be accessible and understandable to everyone, and we work with the conviction that by sharing what we know, we can inspire and motivate others to explore and learn.",
            "drawButton2D": "Go to 2D Nearby Space",
            "show2D": "Show 2D Nearby Space",
            "drawButton3D": "Go to 3D Nearby Space",
            "enterImageName": "Enter the name of the image",
            "imageNamePlaceholder": "Image Name",
            "imageNameRequired": "One field is missing",
            "myDrawings": "My Drawings",
            "myDrawingsAdd": "Add a new drawing",
            "myDrawingsEdit": "Edit Image",
            "edit": "Edit",
            "name": "Name",
            "story": "Story",
            "placeholderName": "Enter new name",
            "placeholderStory": "Enter new story",
            "save": "Save",
            "cancel": "Cancel",
            "textDetails": "Your image details have been updated successfully!",
            "delete": "Delete",
            "deleted": "Deleted",
            "imageDeleted": "The image has been deleted from your account!",
            "confirmDelete": "Are you sure you want to delete this image?",
            "buy_us_a_coffee": "Buy us a coffee",
            "planetRadiusInfo": "Size of the exoplanet compared to the radius of the Earth. For example, if it says 1.5, it means the exoplanet is 1.5 times larger than Earth in radius.",
            "planetMassInfo": "Weight of the exoplanet compared to Earth. For example, if 3000, it means the exoplanet is 3000 times heavier than Earth.",
            "planetEccentricityInfo": "Means how oval the exoplanet's orbit around its star is. For example, a value close to 0 means the orbit is almost circular, while a value close to 1 means the orbit is very oval.",
            "planetGaiaInfo": "Refers to how bright the exoplanet or its star looks from Earth. The lower the number, the brighter the exoplanet or star. Gaia handles its own classification but it is not the only one.",
            "planetOrbitalInfo": "Refers to how long the exoplanet takes to complete a full orbit around its star, measured in days, for example, if it says 200, it means the exoplanet takes 200 days to complete a full orbit around its star, that is, a year in the exoplanet.",
            "planetDistanceInfo": "Refers to how far the exoplanet is from Earth, measured in parsecs, A parsec is an astonomical unit used to simplify data and is equivalent to about 3.26 light years.",
            "planetMethodInfo": "Refers to the technique astronomers used to find the exoplanet.",
            "planetYearInfo": "Year the exoplanet was discovered.",
            "functions": "Discover what you can do",
            "nasa": "NASA's Picture of the Day",
            "exo_planet": "Explore exoplanets with interactive visualizations.",
            "draw_constellation": "Create and customize 2D and 3D drawings with simple and accurate tools.",
            "stellarium_desc": "Observe and explore constellations, stars and other celestial objects in 3D.",
            "nasa_desc": "Explore NASA's Picture of the Day.",
            "blog_desc": "Read our articles about astronomy, science and experiences.",
            "exo": "Exoplanets!",
            "login": "Log In with",
            "google": "oogle",
            "logout": "Log Out",
            "share": "Share",
            "stargram_desc": "Observe constellations created by other people.",
            "tutorialButton": "Tutorial",
            "titleDraw": "Title",
            "titleDrawDescription": "Page title.",
            "searchDraw": "Search Field",
            "searchDrawDescription": "Enter the name of the exoplanet you are looking for.",
            "buttonsDraw": "Action Buttons",
            "buttonsDrawDescription": "Generate a 2D drawing, navigate to 3D mode or follow the usage tutorial.",
            "zoomDraw": "Zoom Controls",
            "zoomDrawDescription": "Zoom in or out of the image.",
            "entendidoDraw": "Understood",
            "closeDraw": "Close",
            "nextDraw": "Next",
            "prevDraw": "Previous",
            "infoDraw": "Information",
            "infoDrawDescription": "Information about the image.",
            "footerDraw": "Floating button to display tools.",
            "footerDrawDescription": "Display tools to draw your constellation, save it, delete or start over.",
            "canvasDraw": "Drawing Canvas",
            "canvasDrawDescription": "Drawing area where the night sky is displayed and you can draw.",
            "sponsors": "Sponsors",
            "education": "Education",
            "technology_software": "Technology and Software",
            "oaxaca": "Oaxaca",
            "fashion_accessories": "Accessories and Fashion",
            "renewable_energy": "Renewable Energy",
            "tech_institutions": "Technology Institutions",
            "scientific_media": "Scientific Media",
            "partnering_with": "Partnering with",
            "contact_opportunities": "Contact and opportunities",
            "contact_opportunities_desc": "Connect with us to explore collaboration opportunities",
            "events": "Events",
            "events_desc": "Participate in our events and special activities",
            "new_talent": "New talent",
            "new_talent_desc": "Discover and support the next generation of innovators",
            "redes":"Our social media",
            "old_members":"Former members"
        }
    },
    es: {
        translation: {
            "welcome": "BIENVENIDO",
            "meet_the_team": "Conoce al Equipo",
            "ezequiel_title": "Ingeniero en Física Aplicada - Universidad Tecnológica de la Mixteca",
            "michelle_title": "Ingeniera en Física Aplicada - Universidad Tecnológica de la Mixteca",
            "erick_title": "Ingeniero en Mecatrónica - Universidad Tecnológica de la Mixteca",
            "tomas_title": "Ingeniero en Mecatrónica - Universidad Tecnológica de la Mixteca",
            "emma_title": "Ingeniera en Mecatrónica - Universidad Tecnológica de la Mixteca",
            "alejandro_title": "Ingeniero en Mecatrónica - Universidad Tecnológica de la Mixteca",
            "jorge_title": "Maestro en Tecnologías de Cómputo Aplicado - Universidad Tecnológica de la Mixteca",
            "omar_title":"Ingeniero en Computacion - Universidad Tecnológica de la Mixteca",
            "engineer": "Ing.",
            "master": "Maestro.",
            "developer": "Desarrollador",
            "constellation": "¡Dibuja tu propia Constelación!",
            "searchPlanet": "Buscar un exoplaneta",
            "success": "Éxito",
            "imageSaved": "¡La imagen ha sido guardada en tu cuenta!",
            "error": "Error",
            "failedToSaveImage": "Error al guardar la imagen.",
            "warning": "Advertencia",
            "needToBeLoggedIn": "Necesitas estar logueado para guardar imágenes en tu cuenta.",
            "pleaseEnterPlanetName": "Por favor, introduce el nombre de un exoplaneta.",
            "loadingStarMap": "Cargando mapa estelar.",
            "errorFetchingStarMap": "Error al obtener el mapa estelar.",
            "errorFetchingStarMapRetry": "Error al obtener el mapa estelar. Por favor, intenta de nuevo.",
            "title_team": "Nuestro equipo",
            "data_planet": "Datos de los exoplanetas",
            "planetName": "Nombre del exoplaneta",
            "planetRadius": "Radio del exoplaneta [veces la Tierra]",
            "planetMass": "Masa del exoplaneta [veces la Tierra]",
            "planetEccentricity": "Excentricidad Orbital",
            "planetGaiaMagnitude": "Magnitud Gaia",
            "planetOrbitalPeriod": "Período Orbital [días]",
            "planetDistance": "Distancia [parsecs]",
            "planetDiscoveredMethod": "Método de Descubrimiento",
            "planetDiscoveredYear": "Año de Descubrimiento",
            "planetHostStar": "Estrella (Hostname)",
            "planetStarsNumber": "Número de Estrellas",
            "planetPlanets" : "Número de Exoplanetas",
            "planetClassification": "Clasificación de las estrellas",
            "drawTitle": "Mapa Estelar",
            "drawButton": "Mostrar espacio cercano 3D",
            "drawP": "Escribe el nombre de un exoplaneta para ver su mapa estelar",
            "blog": "Blog",
            "blogInput": "Buscar un blog",
            "blogRecent": "Publicaciones Recientes",
            "blogOlder": "Publicaciones Anteriores",
            "infoMessage": "La página puede tardar en cargar si no ha habido actividad reciente. Por favor, ten paciencia.",
            "titleMail": "Contáctanos",
            "mail": "Correo Electrónico:",
            "mailType": "Ingresa tu correo electrónico",
            "subject": "Asunto",
            "subjectType": "Ingresa el asunto",
            "phoneNumber": "Número de Teléfono",
            "phoneType": "Ingresa tu número de teléfono",
            "body": "Mensaje, duda, pregunta, comentario, sugerencia, etc.",
            "bodyType": "Escribe aquí",
            "sendEmail": "Enviar",
            "planetDetails": "Detalles del Exoplaneta:",
            "planetComparison": "Comparación de exoplanetas",
            "filterPlanets": "Filtrar Exoplanetas",
            "infoPlanets": "El orden actual de los exoplanetas está basado en la Distancia desde la Tierra, del más cercano al más lejano, o puedes filtrar por nombre de exoplaneta, año de descubrimiento, método de descubrimiento o radio del exoplaneta.",
            "description_team": "Somos un equipo multidisciplinario compuesto por profesionales de diversas áreas. Nuestro objetivo es desarrollar ideas novedosas que no solo aborden problemas actuales, sino que también acerquen el conocimiento y la tecnología a más personas, independientemente de su trasfondo o nivel educativo. Creemos que la información debe ser accesible y comprensible para todos, y trabajamos con la convicción de que al compartir lo que sabemos, podemos inspirar y motivar a otros a explorar y aprender.",
            "drawButton2D": "Ir a Espacio Cercano 2D",
            "show2D": "Mostrar Espacio Cercano 2D",
            "drawButton3D": "Ir a Espacio Cercano 3D",
            "enterImageName": "Ingresa el nombre de la imagen",
            "imageNamePlaceholder": "Nombre de la Imagen",
            "imageNameRequired": "Falta un campo por rellenar",
            "myDrawings": "Mis Dibujos",
            "myDrawingsAdd": "Agregar un nuevo dibujo",
            "myDrawingsEdit": "Editar Imagen",
            "edit": "Editar",
            "name": "Nombre",
            "story": "Historia",
            "placeholderName": "Ingresa nuevo nombre",
            "placeholderStory": "Ingresa nueva historia",
            "save": "Guardar",
            "cancel": "Cancelar",
            "textDetails": "¡Los detalles de tu imagen han sido actualizados exitosamente!",
            "delete": "Eliminar",
            "deleted": "Eliminado",
            "imageDeleted": "¡La imagen ha sido eliminada de tu cuenta!",
            "confirmDelete": "¿Estás seguro de que deseas eliminar esta imagen?",
            "buy_us_a_coffee": "Invítanos un cafecito",
            "planetRadiusInfo": "Tamaño del exoplaneta comparado con el radio de la Tierra. Por ejemplo, si dice 1.5, significa que el exoplaneta es 1.5 veces más grande que la Tierra en radio.",
            "planetMassInfo": "Peso del exoplaneta comparado con la Tierra. Por ejemplo, si 3000, significa que el exoplaneta es 3000 veces más pesado que la Tierra.",
            "planetEccentricityInfo": "Significa qué tan ovalada es la órbita del exoplaneta alrededor de su estrella. Por ejemplo, un valor cercano a 0 significa que la órbita es casi circular, mientras que un valor cercano a 1 significa que la órbita es muy ovalada.",
            "planetGaiaInfo": "Se refiere a qué tan brillante se ve el exoplaneta o su estrella desde la Tierra. Cuanto más bajo sea el número, más brillante es el exoplaneta o la estrella. Gaia maneja su propia clasificación pero no es la única.",
            "planetOrbitalInfo": "Se refiere a cuánto tiempo tarda el exoplaneta en dar una vuelta completa a su estrella, medido en días, por ejemplo, si dice 200, significa que el exoplaneta tarda 200 días en dar una vuelta completa a su estrella, es decir, un año en el exoplaneta.",
            "planetDistanceInfo": "Se refiere a qué tan lejos está el exoplaneta de la Tierra, medido en parsecs, Un parsec es una unidad astonómica usada para simplificar datos y equivale a unos 3.26 años luz.",
            "planetMethodInfo": "Se refiere a la técnica que los atrónomos usaron para encontrar el exoplaneta.",
            "planetYearInfo": "Año en que se descubrió el exoplaneta.",
            "functions": "Descubre lo que puedes hacer",
            "nasa": "Imagen Astronómica del día, elegida por la NASA",
            "exo_planet": "Explora exoplanetas con visualizaciones interactivas.",
            "draw_constellation": "Crea y personaliza dibujos 2D y 3D con herramientas sencillas y precisas.",
            "stellarium_desc": "Observa y explora constelaciones, estrellas y otros objetos celestes en 3D.",
            "nasa_desc": "Explora las imágenes astronómicas del día, elegidas por la NASA.",
            "blog_desc": "Lee nuestros artículos sobre astronomía, ciencia y experiencias.",
            "exo": "¡Exoplanetas!",
            "login": "Inicia sesión con",
            "google": "oogle",
            "logout": "Cerrar Sesión",
            "share": "Compartir",
            "stargram_desc": "Observa constelaciones creadas por otras personas.",
            "tutorialButton": "Tutorial",
            "titleDraw": "Título",
            "titleDrawDescription": "Título de la página.",
            "searchDraw": "Campo de búsqueda",
            "searchDrawDescription": "Ingresa el nombre del exoplaneta que buscas.",
            "buttonsDraw": "Botones de acción",
            "buttonsDrawDescription": "Genera un dibujo 2D, navega al modo 3D o sigue el tutorial de uso.",
            "zoomDraw": "Controles de zoom",
            "zoomDrawDescription": "Acércate o aléjate de la imagen.",
            "entendidoDraw": "Entendido",
            "closeDraw": "Cerrar",
            "nextDraw": "Siguiente",
            "prevDraw": "Anterior",
            "infoDraw": "Información",
            "infoDrawDescription": "Información sobre la imagen.",
            "footerDraw": "Botón flotante para desplegar herramientas.",
            "footerDrawDescription": "Despliega herramientas para dibujar tu constelación, guardarla, borrar o volver a empezar.",
            "canvasDraw": "Lienzo de dibujo",
            "canvasDrawDescription": "Área de dibujo donde se muestra el cielo nocturno y podrás dibujar.",
            "sponsors": "Patrocinadores",
            "education": "Educación",
            "technology_software": "Tecnología y Software",
            "oaxaca": "Oaxaca",
            "fashion_accessories": "Accesorios y Moda",
            "renewable_energy": "Energía Renovable",
            "tech_institutions": "Instituciones de Tecnología",
            "scientific_media": "Medios de Comunicación Científica",
            "partnering_with": "Partnering with",
            "contact_opportunities": "Contacto y oportunidades",
            "contact_opportunities_desc": "Conéctate con nosotros para explorar oportunidades de colaboración",
            "events": "Eventos",
            "events_desc": "Participa en nuestros eventos y actividades especiales",
            "new_talent": "Nuevo talento",
            "new_talent_desc": "Descubre y apoya a la próxima generación de innovadores",
            "redes":"Nuestras redes sociales",
            "old_members":"Antiguos miembros"
        }
    },
    fr: {
        translation: {
            "welcome": "BIENVENUE",
            "meet_the_team": "Rencontrez l'équipe",
            "ezequiel_title": "Ingénieur en physique appliquée - Université technologique de la Mixteca",
            "michelle_title": "Ingénieure en physique appliquée - Université technologique de la Mixteca",
            "erick_title": "Ingénieur en mécatronique - Université technologique de la Mixteca",
            "tomas_title": "Ingénieur en mécatronique - Université technologique de la Mixteca",
            "emma_title": "Ingénieure en mécatronique - Université technologique de la Mixteca",
            "alejandro_title": "Ingénieur en Mécatronique - Université Technologique de la Mixteca",
            "jorge_title": "Master en Technologies Informatiques Appliquées - Université Technologique de la Mixteca",
            "omar_title":"Ingénieur en informatique - Université Technologique de la Mixteca",
            "engineer": "Ing.",
            "master": "Master.",
            "developer": "Développeur",
            "constellation": "Dessinez votre propre constellation !",
            "searchPlanet": "Chercher une exoplanète",
            "success": "Succès",
            "imageSaved": "L'image a été sauvegardée!",
            "error": "Erreur",
            "failedToSaveImage": "Échec de la sauvegarde de l'image.",
            "warning": "Avertissement",
            "needToBeLoggedIn": "Vous devez être connecté pour sauvegarder des images.",
            "pleaseEnterPlanetName": "Veuillez entrer un nom de exoplanète.",
            "loadingStarMap": "Chargement de la carte stellaire.",
            "errorFetchingStarMap": "Erreur lors de la récupération de la carte stellaire.",
            "errorFetchingStarMapRetry": "Erreur lors de la récupération de la carte stellaire. Veuillez réessayer.",
            "title_team": "Notre équipe",
            "data_planet": "Données des exoplanètes",
            "planetName": "Nom de la exoplanète",
            "planetRadius": "Rayon de la exoplanète [fois la Terre]",
            "planetMass": "Masse de la exoplanète [fois la Terre]",
            "planetEccentricity": "Excentricité Orbitale",
            "planetGaiaMagnitude": "Magnitude Gaia",
            "planetOrbitalPeriod": "Période Orbitale [jours]",
            "planetDistance": "Distance [parsecs]",
            "planetDiscoveredMethod": "Méthode de Découverte",
            "planetDiscoveredYear": "Année de Découverte",
            "planetHostStar": "Étoile (Hostname)",
            "planetStarsNumber": "Nombre d'Étoiles",
            "planetPlanets" : "Nombre de Exoplanètes",
            "planetClassification": "Classification des étoiles",
            "drawTitle": "Carte stellaire",
            "drawButton": "Afficher l'espace 3D à proximité",
            "drawP": "Entrez le nom d'une planète pour voir sa carte stellaire",
            "blog": "Blog",
            "blogInput": "Rechercher un blog",
            "blogRecent": "Articles récents",
            "blogOlder": "Articles plus anciens",
            "infoMessage": "La page peut mettre du temps à se charger s'il n'y a pas eu d'activité récente. Veuillez patienter.",
            "titleMail": "Contactez-nous",
            "mail": "Email:",
            "mailType": "Entrez votre email",
            "subject": "Sujet",
            "subjectType": "Entrez le sujet",
            "phoneNumber": "Numéro de téléphone",
            "phoneType": "Entrez votre numéro de téléphone",
            "body": "Message, doute, question, commentaire, suggestion, etc.",
            "bodyType": "Tapez ici",
            "sendEmail": "Envoyer",
            "planetDetails:": "Détails de la exoplanète",
            "planetComparison": "Comparaison des exoplanètes",
            "filterPlanets": "Filtrer les exoplanètes",
            "infoPlanets": "L'ordre actuel des exoplanètes est basé sur la distance par rapport à la Terre, du plus proche au plus éloigné, ou vous pouvez filtrer par nom de planète, année de découver",
            "description_team": "Nous sommes une équipe multidisciplinaire composée de professionnels de différents domaines. Notre objectif est de développer des idées novatrices qui non seulement répondent aux problèmes actuels, mais qui rapprochent également la connaissance et la technologie d'un plus grand nombre de personnes, quel que soit leur parcours ou leur niveau d'éducation. Nous croyons que l'information doit être accessible et compréhensible pour tous, et nous travaillons avec la conviction qu'en partageant ce que nous savons, nous pouvons inspirer et motiver les autres à explorer et à apprendre.",
            "drawButton2D": "Aller à l'Espace Proche 2D",
            "show2D": "Afficher l'Espace Proche 2D",
            "drawButton3D": "Aller à l'Espace Proche 3D",
            "enterImageName": "Entrez le nom de l'image",
            "imageNamePlaceholder": "Nom de l'Image",
            "imageNameRequired": "Il manque un champ à remplir",
            "myDrawings": "Mes Dessins",
            "myDrawingsAdd": "Ajouter un nouveau dessin",
            "myDrawingsEdit": "Modifier l'Image",
            "edit": "Modifier",
            "name": "Nom",
            "story": "Histoire",
            "placeholderName": "Entrez un nouveau nom",
            "placeholderStory": "Entrez une nouvelle histoire",
            "save": "Enregistrer",
            "cancel": "Annuler",
            "textDetails": "Vos détails d'image ont été mis à jour avec succès!",
            "delete": "Supprimer",
            "deleted": "Supprimé",
            "imageDeleted": "L'image a été supprimée de votre compte!",
            "confirmDelete": "Êtes-vous sûr de vouloir supprimer cette image?",
            "buy_us_a_coffee": "Offrez-nous un café",
            "planetRadiusInfo": "Taille de l'exoplanète comparée au rayon de la Terre. Par exemple, si cela dit 1,5, cela signifie que l'exoplanète est 1,5 fois plus grand que la Terre en rayon.",
            "planetMassInfo": "Poids de l'exoplanète comparé à la Terre. Par exemple, si 3000, cela signifie que l'exoplanète est 3000 fois plus lourd que la Terre.",
            "planetEccentricityInfo": "Signifie à quel point l'orbite de la planète autour de son étoile est ovale. Par exemple, une valeur proche de 0 signifie que l'orbite est presque circulaire, tandis qu'une valeur proche de 1 signifie que l'orbite est très ovale.",
            "planetGaiaInfo": "Fait référence à la luminosité de la planète ou de son étoile vue de la Terre. Plus le nombre est bas, plus la planète ou l'étoile est brillante. Gaia gère sa propre classification mais ce n'est pas la seule.",
            "planetOrbitalInfo": "Fait référence à la durée nécessaire à l'exoplanète pour effectuer une orbite complète autour de son étoile, mesurée en jours, par exemple, si cela dit 200, cela signifie que l'exoplanète met 200 jours à effectuer une orbite complète autour de son étoile, c'est-à-dire une année sur l'exoplanète.",
            "planetDistanceInfo": "Fait référence à la distance de la planète par rapport à la Terre, mesurée en parsecs, Un parsec est une unité astronomique utilisée pour simplifier les données et équivaut à environ 3,26 années-lumière.",
            "planetMethodInfo": "Fait référence à la technique utilisée par les astronomes pour trouver la planète.",
            "planetYearInfo": "Année de découverte de la planète.",
            "functions": "Découvrez ce que vous pouvez faire",
            "nasa": "Image du jour de la NASA",
            "exo_planet": "Explorez les exoplanètes avec des visualisations interactives.",
            "draw_constellation": "Créez et personnalisez des dessins 2D et 3D avec des outils simples et précis.",
            "stellarium_desc": "Observez et explorez les constellations, les étoiles et autres objets célestes en 3D.",
            "nasa_desc": "Explorez l'image du jour de la NASA.",
            "blog_desc": "Lisez nos articles sur l'astronomie, la science et les expériences.",
            "exo": "Exoplanètes!",
            "login": "Se connecter avec",
            "google": "oogle",
            "logout": "Se déconnecter",
            "share": "Partager",
            "stargram_desc": "Observez les constellations créées par d'autres personnes.",
            "tutorialButton": "Tutoriel",
            "titleDraw": "Titre",
            "titleDrawDescription": "Titre de la page.",
            "searchDraw": "Champ de recherche",
            "searchDrawDescription": "Entrez le nom de la planète que vous recherchez.",
            "buttonsDraw": "Boutons d'action",
            "buttonsDrawDescription": "Générer un dessin 2D, naviguer en mode 3D ou suivre le tutoriel d'utilisation.",
            "zoomDraw": "Contrôles de zoom",
            "zoomDrawDescription": "Zoomer ou dézoomer l'image.",
            "entendidoDraw": "Compris",
            "closeDraw": "Fermer",
            "nextDraw": "Suivant",
            "prevDraw": "Précédent",
            "infoDraw": "Information",
            "infoDrawDescription": "Information sur l'image.",
            "footerDraw": "Bouton flottant pour afficher les outils.",
            "footerDrawDescription": "Afficher les outils pour dessiner votre constellation, la sauvegarder, la supprimer ou recommencer.",
            "canvasDraw": "Zone de dessin",
            "canvasDrawDescription": "Zone de dessin où le ciel nocturne est affiché et où vous pouvez dessiner.",
            "sponsors": "Partenaires",
            "education": "Éducation",
            "technology_software": "Technologie et Logiciel",
            "oaxaca": "Oaxaca",
            "fashion_accessories": "Accessoires et Mode",
            "renewable_energy": "Énergie Renouvelable",
            "tech_institutions": "Institutions Technologiques",
            "scientific_media": "Médias Scientifiques",
            "partnering_with": "Partenariat avec",
            "contact_opportunities": "Contact et opportunités",
            "contact_opportunities_desc": "Connectez-vous avec nous pour explorer des opportunités de collaboration",
            "events": "Événements",
            "events_desc": "Participez à nos événements et activités spéciales",
            "new_talent": "Nouveau talent",
            "new_talent_desc": "Découvrez et soutenez la prochaine génération d'innovateurs",
            "redes":"Nos réseaux sociaux",
            "old_members":"Anciens membres"
        }
    },
    zh: {
        translation: {
            "welcome": "欢迎",
            "meet_the_team": "认识团队",
            "ezequiel_title": "应用物理工程师 - 米克斯特克技术大学",
            "michelle_title": "应用物理工程师 - 米克斯特克技术大学",
            "erick_title": "机电一体化工程师 - 米克斯特克技术大学",
            "tomas_title": "机电一体化工程师 - 米克斯特克技术大学",
            "emma_title": "机电一体化工程师 - 米克斯特克技术大学",
            "alejandro_title": "机电工程师 - 米克斯特克技术大学",
            "jorge_title": "应用计算机技术硕士 - 米克斯特克技术大学",
            "omar_title":"计算机工程师- 米克斯特克技术大学",
            "engineer": "Eng.",
            "master": "Master.",
            "developer": "开发者",
            "constellation": "画出你自己的星座！",
            "searchPlanet": "搜索行星",
            "success": "成功",
            "imageSaved": "图片已保存！",
            "error": "错误",
            "failedToSaveImage": "保存图片失败。",
            "warning": "警告",
            "needToBeLoggedIn": "您需要登录才能保存图片。",
            "pleaseEnterPlanetName": "请输入行星名称。",
            "loadingStarMap": "正在加载星图",
            "errorFetchingStarMap": "获取星图时出错。",
            "errorFetchingStarMapRetry": "获取星图时出错。请重试。",
            "title_team": "我们的团队",
            "data_planet": "行星数据",
            "planetName": "行星名称",
            "planetRadius": "行星半径 [地球倍]",
            "planetMass": "行星质量 [地球倍]",
            "planetEccentricity": "轨道离心率",
            "planetGaiaMagnitude": "盖亚星等",
            "planetOrbitalPeriod": "轨道周期 [天]",
            "planetDistance": "距离 [秒差距]",
            "planetDiscoveredMethod": "发现方法",
            "planetDiscoveredYear": "发现年份",
            "planetHostStar": "主星",
            "planetStarsNumber": "星数",
            "planetPlanets" : "行星数",
            "planetClassification": "星的分类",
            "drawTitle": "星图",
            "drawButton": "显示3D附近空间",
            "drawP": "输入行星名称查看其星图",
            "blog": "博客",
            "blogInput": "搜索博客",
            "blogRecent": "最近文章",
            "blogOlder": "更早文章",
            "infoMessage": "如果没有最近活动，页面可能需要一段时间才能加载。请耐心等待。",
            "titleMail": "联系我们",
            "mail": "电子邮件：",
            "mailType": "输入您的电子邮件",
            "subject": "主题",
            "subjectType": "输入主题",
            "phoneNumber": "电话号码",
            "phoneType": "输入您的电话号码",
            "body": "消息，疑问，问题，评论，建议等。",
            "bodyType": "在此输入",
            "sendEmail": "发送",
            "planetDetails": "行星详细信息",
            "planetComparison": "行星比较",
            "filterPlanets": "过滤行星",
            "infoPlanets": "外行星的实际顺序是基于距离地球的距离，从最近到最远，或者您可以按行星名称、发现年份、发现方法或行星半径进行过滤。",
            "description_team": "我们是一个由不同领域的专业人士组成的多学科团队，致力于创造创新解决方案，产生积极影响。我们的目标是开发新颖的想法，不仅解决当前问题，而且将知识和技术带给更多人，无论他们的背景或教育水平如何。我们相信信息应该对每个人都是可访问和可理解的，我们坚信通过分享我们所知道的，我们可以激励和激励他人探索和学习。",
            "drawButton2D": "转到2D附近空间",
            "show2D": "显示2D附近空间",
            "drawButton3D": "转到3D附近空间",
            "enterImageName": "输入图片名称",
            "imageNamePlaceholder": "图片名称",
            "imageNameRequired": "有一个字段未填写",
            "myDrawings": "我的绘画",
            "myDrawingsAdd": "添加新绘画",
            "myDrawingsEdit": "编辑图片",
            "edit": "编辑",
            "name": "名称",
            "story": "故事",
            "placeholderName": "输入新名称",
            "placeholderStory": "输入新故事",
            "save": "保存",
            "cancel": "取消",
            "textDetails": "您的图片细节已成功更新",
            "delete": "删除",
            "deleted": "已删除",
            "imageDeleted": "该图片已从您的帐户中删除！",
            "confirmDelete": "您确定要删除此图片吗？",
            "buy_us_a_coffee": "请我们喝咖啡",
            "planetRadiusInfo": "与地球半径相比的外行星大小。例如，如果说1.5，这意味着外行星的半径是地球的1.5倍。",
            "planetMassInfo": "与地球相比的外行星重量。例如，如果是3000，这意味着外行星比地球重3000倍。",
            "planetEccentricityInfo": "表示行星围绕其恒星的轨道有多椭圆。例如，接近0的值表示轨道几乎是圆形的，而接近1的值表示轨道非常椭圆。",
            "planetGaiaInfo": "指的是地球上看到的行星或恒星的亮度。数字越低，行星或恒星越亮。盖亚处理自己的分类，但不是唯一的。",
            "planetOrbitalInfo": "指的是外行星完成绕其恒星的完整轨道所需的时间，以天为单位。例如，如果说200，这意味着外行星需要200天才能完成绕其恒星的完整轨道，也就是外行星的一年。",
            "planetDistanceInfo": "指的是行星距离地球有多远，以秒差距为单位。秒差距是用于简化数据的天文单位，相当于大约3.26光年。",
            "planetMethodInfo": "指的是天文学家用来发现行星的技术。",
            "planetYearInfo": "发现行星的年份。",
            "functions": "发现您可以做什么",
            "nasa": "NASA每日图片",
            "exo_planet": "通过交互式可视化探索外行星。",
            "draw_constellation": "使用简单准确的工具创建和定制2D和3D绘图。",
            "stellarium_desc": "在3D中观察和探索星座、恒星和其他天体。",
            "nasa_desc": "探索NASA每日图片。",
            "blog_desc": "阅读我们关于天文学、科学和经验的文章。",
            "exo": "外行星！",
            "login": "使用以下登录",
            "google": "oogle",
            "logout": "登出",
            "share": "分享",
            "stargram_desc": "观察其他人创建的星座。",
            "tutorialButton": "教程",
            "titleDraw": "标题",
            "titleDrawDescription": "页面标题。",
            "searchDraw": "搜索字段",
            "searchDrawDescription": "输入您要查找的行星名称。",
            "buttonsDraw": "操作按钮",
            "buttonsDrawDescription": "生成2D图，切换到3D模式或查看使用教程。",
            "zoomDraw": "缩放控件",
            "zoomDrawDescription": "放大或缩小图片。",
            "entendidoDraw": "明白",
            "closeDraw": "关闭",
            "nextDraw": "下一个",
            "prevDraw": "上一个",
            "infoDraw": "信息",
            "infoDrawDescription": "关于图片的信息。",
            "footerDraw": "浮动按钮以显示工具。",
            "footerDrawDescription": "显示工具以绘制您的星座、保存、删除或重新开始。",
            "canvasDraw": "绘图区",
            "canvasDrawDescription": "显示夜空并进行绘图的区域。",
            "sponsors": "赞助商",
            "education": "教育",
            "technology_software": "技术与软件",
            "oaxaca": "瓦哈卡",
            "fashion_accessories": "时尚与配饰",
            "renewable_energy": "可再生能源",
            "tech_institutions": "技术机构",
            "scientific_media": "科学媒体",
            "partnering_with": "合作伙伴",
            "contact_opportunities": "联系与机会",
            "contact_opportunities_desc": "与我们联系以探索合作机会",
            "events": "活动",
            "events_desc": "参加我们的活动和特别活动",
            "new_talent": "新人才",
            "new_talent_desc": "发现并支持下一代创新者",
            "redes":"我们的社交网络",
            "old_members":"前成员"
        }
    },
    de: {
        translation: {
            "welcome": "WILLKOMMEN",
            "meet_the_team": "Das Team kennenlernen",
            "ezequiel_title": "Angewandter Physikingenieur - Technologische Universität von Mixteca",
            "michelle_title": "Angewandte Physikingenieurin - Technologische Universität von Mixteca",
            "erick_title": "Mechatronikingenieur - Technologische Universität von Mixteca",
            "tomas_title": "Mechatronikingenieur - Technologische Universität von Mixteca",
            "emma_title": "Mechatronikingenieurin - Technologische Universität von Mixteca",
            "alejandro_title": "Mechatronik-Ingenieur - Technologische Universität von Mixteca",
            "jorge_title": "Master of Science in Angewandter Informatik - Technologische Universität von Mixteca",
            "omar_title":"Informatikingenieur- Technologische Universität von Mixteca",
            "engineer": "Ing.",
            "master": "Master.",
            "developer": "Entwickler",
            "constellation": "Zeichne deine eigene Konstellation!",
            "searchPlanet": "Nach einem Planeten suchen",
            "success": "Erfolg",
            "imageSaved": "Bild wurde gespeichert!",
            "error": "Fehler",
            "failedToSaveImage": "Bild konnte nicht gespeichert werden.",
            "warning": "Warnung",
            "needToBeLoggedIn": "Sie müssen angemeldet sein, um Bilder zu speichern.",
            "pleaseEnterPlanetName": "Bitte geben Sie einen Planeten-Namen ein.",
            "loadingStarMap": "Sterrenkaart wordt geladen",
            "errorFetchingStarMap": "Fehler beim Abrufen der Sternenkarte.",
            "errorFetchingStarMapRetry": "Fehler beim Abrufen der Sternenkarte. Bitte versuchen Sie es erneut.",
            "title_team": "Unser Team",
            "data_planet": "Daten der Planeten",
            "planetName": "Planetennamen",
            "planetRadius": "Planetendurchmesser [Erdradien]",
            "planetMass": "Planetmasse [Erdradien]",
            "planetEccentricity": "Orbitale Exzentrizität",
            "planetGaiaMagnitude": "Gaia-Magnitude",
            "planetOrbitalPeriod": "Umlaufszeit [Tage]",
            "planetDistance": "Entfernung [Parsecs]",
            "planetDiscoveredMethod": "Entdeckungsmethode",
            "planetDiscoveredYear": "Entdeckungsjahr",
            "planetHostStar": "Stern (Hostname)",
            "planetStarsNumber": "Anzahl der Sterne",
            "planetPlanets" : "Anzahl der Planeten",
            "planetClassification": "Klassifizierung der Sterne",
            "drawTitle": "Sternenkarte",
            "drawButton": "3D-Nahbereich anzeigen",
            "drawP": "Geben Sie den Namen eines Planeten ein, um seine Sternenkarte anzuzeigen",
            "blog": "Blog",
            "blogInput": "Suche nach einem Blog",
            "blogRecent": "Neueste Beiträge",
            "blogOlder": "Ältere Beiträge",
            "infoMessage": "Die Seite kann eine Weile dauern, um zu laden, wenn es keine kürzliche Aktivität gab. Bitte haben Sie Geduld.",
            "titleMail": "Kontaktiere uns",
            "mail": "Email:",
            "mailType": "Geben Sie Ihre E-Mail-Adresse ein",
            "subject": "Betreff",
            "subjectType": "Geben Sie den Betreff ein",
            "phoneNumber": "Telefonnummer",
            "phoneType": "Geben Sie Ihre Telefonnummer ein",
            "body": "Nachricht, Zweifel, Frage, Kommentar, Vorschlag, etc.",
            "bodyType": "Geben Sie hier ein",
            "sendEmail": "Schicken",
            "planetDetails":"Planetendetails:",
            "planetComparison": "Planetenvergleich",
            "filterPlanets": "Planeten filtern",
            "infoPlanets": "Die aktuelle Reihenfolge der Exoplaneten basiert auf der Entfernung von der Erde, vom nächsten zum weitesten, oder Sie können nach Planetennamen, Entdeckungsjahr, Entdeckungsmethode oder Planetendurchmesser filtern.",
            "description_team": "Wir sind ein multidisziplinäres Team von Fachleuten aus verschiedenen Bereichen. Unser Ziel ist es, neue Ideen zu entwickeln, die nicht nur aktuelle Probleme lösen, sondern auch Wissen und Technologie einem größeren Personenkreis näherbringen, unabhängig von ihrem Hintergrund oder Bildungsniveau. Wir sind der Meinung, dass Informationen für alle zugänglich und verständlich sein sollten, und wir arbeiten mit der Überzeugung, dass wir durch das Teilen unseres Wissens andere inspirieren und motivieren können, zu erkunden und zu lernen.",
            "drawButton2D": "Zu 2D-Nahbereich gehen",
            "show2D": "2D-Nahbereich anzeigen",
            "drawButton3D": "Zu 3D-Nahbereich gehen",
            "enterImageName": "Geben Sie den Namen des Bildes ein",
            "imageNamePlaceholder": "Bildname",
            "imageNameRequired": "Ein Feld muss noch ausgefüllt werden",
            "myDrawings": "Meine Zeichnungen",
            "myDrawingsAdd": "Neue Zeichnung hinzufügen",
            "myDrawingsEdit": "Bild bearbeiten",
            "edit": "Bearbeiten",
            "name": "Name",
            "story": "Geschichte",
            "placeholderName": "Neuen Namen eingeben",
            "placeholderStory": "Neue Geschichte eingeben",
            "save": "Speichern",
            "cancel": "Abbrechen",
            "textDetails": "Ihre Bildinformationen wurden erfolgreich aktualisiert!",
            "delete": "Löschen",
            "deleted": "Gelöscht",
            "imageDeleted": "Das Bild wurde aus Ihrem Konto gelöscht!",
            "confirmDelete": "Sind Sie sicher, dass Sie dieses Bild löschen möchten?",
            "buy_us_a_coffee": "Spendieren Sie uns einen Kaffee",
            "planetRadiusInfo": "Größe des Exoplaneten im Vergleich zum Radius der Erde. Wenn es z.B. 1,5 heißt, bedeutet dies, dass der Exoplanet 1,5-mal größer als die Erde im Radius ist.",
            "planetMassInfo": "Gewicht des Exoplaneten im Vergleich zur Erde. Wenn 3000 z.B. bedeutet dies, dass der Exoplanet 3000-mal schwerer als die Erde ist.",
            "planetEccentricityInfo": "Bedeutet, wie oval die Umlaufbahn des Planeten um seinen Stern ist. Wenn ein Wert nahe 0 liegt, ist die Umlaufbahn fast kreisförmig, während ein Wert nahe 1 bedeutet, dass die Umlaufb Bahn sehr oval ist.",
            "planetGaiaInfo": "Bezieht sich darauf, wie hell der Planet oder sein Stern von der Erde aus aussieht. Je niedriger die Zahl, desto heller der Planet oder der Stern. Gaia behandelt seine eigene Klassifizierung, aber es ist nicht die einzige.",
            "planetOrbitalInfo": "Bezieht sich darauf, wie lange der Exoplanet benötigt, um eine vollständige Umlaufbahn um seinen Stern zu machen, gemessen in Tagen. Wenn es z.B. 200 heißt, bedeutet dies, dass der Exoplanet 200 Tage benötigt, um eine vollständige Umlaufbahn um seinen Stern zu machen, d.h. ein Jahr auf dem Exoplaneten.",
            "planetDistanceInfo": "Bezieht sich darauf, wie weit der Planet von der Erde entfernt ist, gemessen in Parsecs. Ein Parsec ist eine astronomische Einheit, die zur Vereinfachung von Daten verwendet wird und etwa 3,26 Lichtjahre entspricht.",
            "planetMethodInfo": "Bezieht sich auf die Technik, die Astronomen verwendet haben, um den Planeten zu finden.",
            "planetYearInfo": "Jahr, in dem der Planet entdeckt wurde.",
            "functions": "Entdecken Sie, was Sie tun können",
            "nasa": "NASA Astronomisches Bild des Tages",
            "exo_planet": "Erkunden Sie Exoplaneten mit interaktiven Visualisierungen.",
            "draw_constellation": "Erstellen und individualisieren Sie 2D- und 3D-Zeichnungen mit einfachen und präzisen Werkzeugen.",
            "stellarium_desc": "Beobachten und erkunden Sie Konstellationen, Sterne und andere Himmelskörper in 3D.",
            "nasa_desc": "Erkunden Sie die astronomischen Bilder des Tages, ausgewählt von der NASA.",
            "blog_desc": "Lesen Sie unsere Artikel über Astronomie, Wissenschaft und Erfahrungen.",
            "exo": "Exoplaneten!",
            "login": "Mit folgendem anmelden",
            "google": "oogle",
            "logout": "Abmelden",
            "share": "Teilen",
            "stargram_desc": "Beobachten Sie Konstellationen, die von anderen erstellt wurden.",
            "tutorialButton": "Tutorial",
            "titleDraw": "Titel",
            "titleDrawDescription": "Seitentitel.",
            "searchDraw": "Suchfeld",
            "searchDrawDescription": "Geben Sie den Namen des Planeten ein, den Sie suchen.",
            "buttonsDraw": "Aktionsknöpfe",
            "buttonsDrawDescription": "Generieren Sie eine 2D-Zeichnung, navigieren Sie im 3D-Modus oder folgen Sie dem Verwendungstutorial.",
            "zoomDraw": "Zoomsteuerung",
            "zoomDrawDescription": "Vergrößern oder verkleinern Sie das Bild.",
            "entendidoDraw": "Verstanden",
            "closeDraw": "Schließen",
            "nextDraw": "Weiter",
            "prevDraw": "Zurück",
            "infoDraw": "Information",
            "infoDrawDescription": "Informationen zum Bild.",
            "footerDraw": "Schaltfläche zum Anzeigen von Werkzeugen.",
            "footerDrawDescription": "Zeigen Sie Werkzeuge an, um Ihre Konstellation zu zeichnen, zu speichern, zu löschen oder neu zu starten.",
            "canvasDraw": "Zeichenbereich",
            "canvasDrawDescription": "Bereich zum Zeichnen, in dem der Nachthimmel angezeigt wird.",
            "sponsors": "Sponsoren",
            "education": "Bildung",
            "technology_software": "Technologie und Software",
            "oaxaca": "Oaxaca",
            "fashion_accessories": "Mode und Accessoires",
            "renewable_energy": "Erneuerbare Energien",
            "tech_institutions": "Technologische Institutionen",
            "scientific_media": "Wissenschaftliche Medien",
            "partnering_with": "Partner",
            "contact_opportunities": "Kontakt und Möglichkeiten",
            "contact_opportunities_desc": "Verbinden Sie sich mit uns, um Kooperationsmöglichkeiten zu erkunden",
            "events": "Veranstaltungen",
            "events_desc": "Nehmen Sie an unseren Veranstaltungen und besonderen Aktivitäten teil",
            "new_talent": "Neues Talent",
            "new_talent_desc": "Entdecken und unterstützen Sie die nächste Generation von Innovatoren",
            "redes":"Unsere sozialen Netzwerke",
            "old_members":"Ehemalige Mitglieder"
        }
    }
};

i18n.use(initReactI18next).init({
    resources,
    lng: localStorage.getItem('i18nextLng') || "en",
    interpolation: {
        escapeValue: false,
    }
});

export default i18n;
